import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static classes = ["active", "inactive"]
  static values = { default: { type: String, default: "" } }

  connect() {
    const urlTab = new URLSearchParams(window.location.search).get("tab")
    const initial = urlTab || this.defaultValue || this.tabTargets[0]?.dataset.panel
    if (initial) this.show(initial)
  }

  switch(event) {
    event.preventDefault()
    const panelId = event.currentTarget.dataset.panel
    this.show(panelId)
  }

  show(panelId) {
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.panel === panelId
      this.activeClasses.forEach(cls => tab.classList.toggle(cls, isActive))
      this.inactiveClasses.forEach(cls => tab.classList.toggle(cls, !isActive))
      tab.setAttribute("aria-selected", isActive)
    })

    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.id !== `panel-${panelId}`)
    })

    const url = new URL(window.location)
    url.searchParams.set("tab", panelId)
    window.history.replaceState({}, "", url)
  }
}
